import { render, staticRenderFns } from "./TechnologyIssue.vue?vue&type=template&id=0f9b484e&scoped=true&"
import script from "./TechnologyIssue.vue?vue&type=script&lang=js&"
export * from "./TechnologyIssue.vue?vue&type=script&lang=js&"
import style0 from "./TechnologyIssue.vue?vue&type=style&index=0&id=0f9b484e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9b484e",
  null
  
)

export default component.exports